import axios, { AxiosResponse } from 'axios';
import { getApiEndpoint, getAppInfo } from '@ygoargentina/sdk/api/api.types';

const axiosClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send cookies with cross-origin requests
});

// Interceptor para configurar la baseURL y headers dinámicamente en cada petición
axiosClient.interceptors.request.use((config) => {
  config.baseURL = getApiEndpoint();

  const appInfo = getAppInfo();
  if (appInfo) {
    config.headers['X-ygoarg-service'] = appInfo.service;
    config.headers['X-ygoarg-app-version'] = appInfo.version;
    if (appInfo.commitHash) {
      config.headers['X-ygoarg-app-hash'] = appInfo.commitHash;
    }
  }

  return config;
});

const responseInterceptor = (response: AxiosResponse<any, any>) => {
  if (response.config.responseType === 'blob') {
    return response;
  }

  if (response.headers['content-type']?.includes('text/csv')) {
    return {
      data: response.data,
      fileName: response.headers['content-filename'],
    };
  }

  if (response.headers['content-type']?.includes('application/pdf')) {
    return {
      data: response.data,
      fileName: response.headers['content-filename'],
    };
  }

  if (response.data.meta) {
    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  }

  return response.data;
};

axiosClient.interceptors.response.use(
  (response) => responseInterceptor(response),
  (err) => {
    throw err.response.data;
  }
);

export default axiosClient;
